module.exports = __webpack_public_path__ + "static/img/Ellipse 5.aec0bcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/medicalInformationReply/assets/Ellipse 5.png
// module id = 0Kun
// module chunks = 1